import { render, staticRenderFns } from "./invite-regular-user-dialog.component.vue?vue&type=template&id=791bf756"
import script from "./invite-regular-user-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./invite-regular-user-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports